import type { FC } from "react";
import { Content } from "src/shared/components/content";
import {
  DownloadContent,
  DownloadContentHighlight,
  DownloadTitle,
  StyledImageDiv,
  StyledImageWithLink,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { MetricsBackground } from "src/website-apps/shared/components/branding/styled-components";

const linkTitles = ["Apple App Store", "Google Play"] as const;

interface DownloadAppsProps {
  readonly images: readonly string[];
  readonly links: readonly string[];
}

export const DownloadApps: FC<DownloadAppsProps> = ({ images, links }) => (
  <MetricsBackground>
    <DownloadTitle>
      <Content id="cid$#1907020#" />
    </DownloadTitle>
    <DownloadContentHighlight>
      <Content id="cid$#1907021#" />
    </DownloadContentHighlight>
    <DownloadContent>
      <Content id="cid$#1907022#" />
    </DownloadContent>
    <StyledImageDiv>
      {images.map((image, index) => (
        <StyledImageWithLink
          key={index}
          alt={linkTitles[index]}
          src={image}
          size={{
            width: 160,
            height: 48,
          }}
          linkUrl={links[index] ?? ""}
          linkTitle={linkTitles[index] ?? ""}
        />
      ))}
    </StyledImageDiv>
  </MetricsBackground>
);
